/* eslint-disable max-statements */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import classNames from 'classnames';
import icCopy from 'assets/svg/ic_copy_s.svg';
import icArrowRight from 'assets/svg/ic_arrow_right_V2.svg';
import icChangeAvatar from 'assets/svg/ic_change_avatar.svg';
import styles from './styles.module.scss';
import ImageWithPlaceholder from '@profile/src/Components/ImageWithPlaceHolder';
import Spinner from '@profile/src/Components/Spinner';
import { ellipsisMiddle } from '@profile/src/utils/text';
import Text from '@profile/src/Components/Text';
import { menuList } from '../../config';
import QRPopup from '../QRPopup';
import { useTypedSelector } from '@profile/src/redux/utils';
import Button from '@profile/src/Components/Button';
import { makeSelectCurrentAvatar, makeSelectCurrentAvatarFrame } from './selectors';
import { webImageUri } from '@profile/src/utils/uri';
import ChooseAvatarModal from './ChooseAvatarModal';
import { useTooltip } from '@profile/src/Components/TooltipProvider';
import { TooltipDirection } from '@profile/src/Components/TooltipProvider/Tooltip';
import BreakpointContent from '@profile/src/Components/BreakpointContent';
import { InGameCategoryKey } from '@profile/src/Profile_V2/Components/Ingame/types';
import TooltipContent from './TooltipContent';
import { ReactTooltip, TooltipPosition } from '@profile/src/Components/TooltipProviderV2';
import { copyToClipboard } from '@profile/src/utils/copyToClipboard';

const NavBar = ({
  className,
  selectedMenu,
  onMenuChange,
  selectedCategory
}) => {
  const username = useTypedSelector(state => {
    var _state$userProfile$us;

    return ((_state$userProfile$us = state.userProfile.user) === null || _state$userProfile$us === void 0 ? void 0 : _state$userProfile$us.username) || '';
  });
  const account = useTypedSelector(state => {
    var _state$userProfile$us2;

    return ((_state$userProfile$us2 = state.userProfile.user) === null || _state$userProfile$us2 === void 0 ? void 0 : _state$userProfile$us2.address) || '';
  });
  const selectCurrentAvatar = React.useRef(makeSelectCurrentAvatar());
  const avatar = useTypedSelector(selectCurrentAvatar.current);
  const selectCurrentAvatarFrame = React.useRef(makeSelectCurrentAvatarFrame());
  const avatarFrame = useTypedSelector(selectCurrentAvatarFrame.current);
  const [isQRVisible, setQRVisible] = React.useState(false);
  const [toggleModal, setToggleModal] = React.useState(false);

  const handleCopyAddress = () => {
    copyToClipboard(account);
  };

  const handleToggleAvatar = () => {
    setToggleModal(true);
  };

  const imgRef = React.useRef(null);
  const spanRef = React.useRef(null);
  const tooltip = useTooltip();
  const ref = React.useRef(null);
  const [isSticky, setIsSticky] = React.useState(false);
  const [hasShowMore, setHasShowMore] = React.useState(false);
  React.useEffect(() => {
    if (ref.current) {
      const cachedRef = ref.current;
      const observer = new IntersectionObserver(([e]) => {
        setIsSticky(e.intersectionRatio < 1);
      }, {
        threshold: 1
      });
      observer.observe(cachedRef);
      return () => {
        observer.unobserve(cachedRef);
      };
    }

    return undefined;
  }, [ref]);

  const onPress = (top, left) => {
    tooltip.show('Copied', {
      top,
      left
    }, TooltipDirection.BOTTOM, {
      backgroundColor: '#261858',
      textColor: '#fff',
      delay: 1500
    });
  };

  const renderMenuWithoutChildren = menu => {
    return /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        onMenuChange(menu);
      },
      className: classNames(styles.item, selectedMenu.key === menu.key && styles.active)
    }, menu.icon ? /*#__PURE__*/React.createElement("img", {
      className: styles.icon,
      src: menu.icon
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, menu.name));
  };

  const renderMenuWithChildren = menu => {
    var _menu$children;

    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.item, styles.hasChildren)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.parentMenu
    }, menu.icon ? /*#__PURE__*/React.createElement("img", {
      className: styles.icon,
      src: menu.icon
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, menu.name)), /*#__PURE__*/React.createElement("div", {
      className: styles.childMenu
    }, (_menu$children = menu.children) === null || _menu$children === void 0 ? void 0 : _menu$children.map(children => /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        onMenuChange(menu, InGameCategoryKey.BattleRewards);
      },
      className: classNames(styles.item, selectedCategory === InGameCategoryKey.BattleRewards && styles.active),
      key: children.key
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, children.name)))));
  };

  const renderMenuDesktopTablet = menuList => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: styles.hidden
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.menu
  }, menuList.map(item => {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.key
    }, item.children && renderMenuWithChildren(item), !item.children && renderMenuWithoutChildren(item));
  })));

  const renderMenuMobile = menuList => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: styles.hidden
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.menu
    }, menuList.map(item => !item.inDropdownMenu && /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        onMenuChange(item);
      },
      className: classNames(styles.item, selectedMenu.key === item.key && styles.active),
      key: item.key
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, item.name))), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.item, styles.more),
      onClick: () => setHasShowMore(prev => !prev)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, "More ", /*#__PURE__*/React.createElement("img", {
      src: icArrowRight,
      className: styles.icArrowDown
    })), /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.dropdownMenu, hasShowMore ? null : styles.hidden)
    }, menuList.map(item => item.inDropdownMenu && /*#__PURE__*/React.createElement("div", {
      onClick: e => {
        e.stopPropagation();
        onMenuChange(item);
        setHasShowMore(false);
      },
      className: classNames(styles.dropdownItem, selectedMenu.key === item.key && styles.active),
      key: item.key
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, item.name)))))));
  };

  const renderButtonQR = () => /*#__PURE__*/React.createElement(Button, {
    disabled: true,
    onClick: () => setQRVisible(true),
    className: styles.btnQR,
    title: "Show QR"
  });

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.backgroundFluid
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.user
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contentUser
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.avatar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.avatarImg,
    onClick: handleToggleAvatar
  }, avatar && /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
    className: styles.portrait,
    src: webImageUri(avatar.imageAvatar),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: 80,
      className: styles.portrait
    })
  }), avatarFrame && /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
    className: styles.portraitFrame,
    src: webImageUri(avatarFrame),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: 80,
      className: styles.portrait
    })
  }), /*#__PURE__*/React.createElement(ReactTooltip, {
    content: /*#__PURE__*/React.createElement(TooltipContent, null),
    position: TooltipPosition.BOTTOM,
    className: styles.tooltip
  }, /*#__PURE__*/React.createElement("img", {
    src: icChangeAvatar,
    alt: "change avatar",
    className: styles.changeAvatar
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.name
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1
  }, username)), /*#__PURE__*/React.createElement("div", {
    onClick: handleCopyAddress,
    className: styles.code
  }, /*#__PURE__*/React.createElement("span", {
    ref: spanRef,
    onClick: () => {
      if (spanRef.current) {
        const rect = spanRef.current.getBoundingClientRect();
        onPress(rect.top + document.documentElement.scrollTop + 30, rect.left + document.documentElement.scrollLeft + rect.width / 2);
      }
    },
    className: styles.uuid
  }, ellipsisMiddle(account)), /*#__PURE__*/React.createElement("img", {
    ref: imgRef,
    className: styles.copy,
    onClick: () => {
      if (imgRef.current) {
        const rect = imgRef.current.getBoundingClientRect();
        onPress(rect.top + document.documentElement.scrollTop + 30, rect.left + document.documentElement.scrollLeft + rect.width / 2);
      }
    },
    src: icCopy
  })), /*#__PURE__*/React.createElement(BreakpointContent, {
    renderDesktop: () => null,
    renderPhone: () => null,
    renderTablet: renderButtonQR
  }))), /*#__PURE__*/React.createElement(BreakpointContent, {
    renderDesktop: renderButtonQR,
    renderPhone: renderButtonQR,
    renderTablet: () => null
  })), /*#__PURE__*/React.createElement(BreakpointContent, {
    renderPhone: () => null,
    renderTablet: () => null,
    renderDesktop: () => renderMenuDesktopTablet(menuList)
  })), /*#__PURE__*/React.createElement(QRPopup, {
    onClose: () => setQRVisible(false),
    isVisible: isQRVisible
  }), toggleModal && /*#__PURE__*/React.createElement(ChooseAvatarModal, {
    onClose: () => setToggleModal(false),
    onSuccess: () => {
      setToggleModal(false);
    },
    avatarImage: avatar === null || avatar === void 0 ? void 0 : avatar.imageAvatar,
    avatarFrameImage: avatarFrame
  }), /*#__PURE__*/React.createElement(BreakpointContent, {
    renderPhone: () => renderMenuMobile(menuList),
    renderTablet: () => renderMenuDesktopTablet(menuList),
    renderDesktop: () => null
  }));
};

export default NavBar;